export default "__VITE_ASSET__9bdcdcb9__"